<script lang="ts">
    import { fly } from "svelte/transition";
    import { toastStore } from "../../stores/toastStore";
</script>

<div
    class="notification-container"
    style="position: fixed; bottom: 1rem; right: 1rem; z-index: 2000;"
>
    {#each $toastStore as notif (notif.id)}
        <div
            class="notification {notif.type}"
            transition:fly={{ y: 50, duration: 300 }}
        >
            <p>{notif.message}</p>
        </div>
    {/each}
</div>

<style>
    .notification {
        padding: 1rem 1.5rem;
        margin-bottom: 0.5rem;
        border-radius: 0.5rem;
        color: white;
        font-weight: bold;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
        z-index: 2000; 
    }

    .notification.info {
        background-color: #2196f3;
    }
    .notification.success {
        background-color: #4caf50;
    }
    .notification.warning {
        background-color: #ff9800;
    }
    .notification.error {
        background-color: #f44336;
    }
</style>
